module.exports = __webpack_public_path__ + "static/media/bg_login.9c4a2542.jpg";